import { render, staticRenderFns } from "./BulkAssignLead.vue?vue&type=template&id=fd740748&scoped=true"
import script from "./BulkAssignLead.vue?vue&type=script&lang=js"
export * from "./BulkAssignLead.vue?vue&type=script&lang=js"
import style0 from "./BulkAssignLead.vue?vue&type=style&index=0&id=fd740748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd740748",
  null
  
)

export default component.exports